import { AvatarBuilder } from '@amplify/avatar-builder';
import kebabCase from 'lodash.kebabcase';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AvatarBuilderHeader } from 'src/components/avatar-builder';
import { LoadingScreen } from 'src/components/common/loaders';
import { useAvatar } from 'src/hooks/use-avatar.hook';
import { useDesmosLesson } from 'src/hooks/use-desmos-lesson.hook';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { usePresentation } from 'src/hooks/use-presentation.hook';
import authService from 'src/services/api/auth.service';
import eventService from 'src/services/event.service';
import {
  useCurrentGradeSelector,
  useIsGradeDefinedSelector,
  useIsViewDefinedSelector,
} from 'src/store/features';

import './avatar-builder-page.styles.scss';

export const AvatarBuilderPage = () => {
  const currentGrade = useCurrentGradeSelector();
  const isGradeDefined = useIsGradeDefinedSelector();
  const isViewDefined = useIsViewDefinedSelector();
  const { updateConfig } = window.AmpNavigationV2Module ?? {};

  const navigate = useNavigate();
  const isMiddleSchoolView = useIsMiddleSchoolView();

  const kc = authService.getKC();

  const { characterAssets, saveAvatar } = useAvatar(currentGrade);
  const isLoadingPresentation = usePresentation();
  const isDesmosLessonLoading = useDesmosLesson();

  const showTeacherAvatarBuilder = authService.isTeacher();

  const showMiddleSchoolAvatarBuilder =
    authService.isStudent() && isMiddleSchoolView;

  useEffect(() => {
    if (!updateConfig) return;
    updateConfig({ hideNavigation: true });
    return () => {
      updateConfig({ hideNavigation: false });
    };
  }, [updateConfig]);

  if (isLoadingPresentation || isDesmosLessonLoading)
    return <LoadingScreen isJoiningLesson />;

  if (!isGradeDefined || !isViewDefined) return null;

  return (
    <div className="page">
      <AvatarBuilderHeader />
      <div className="avatar-builder-wrapper">
        <AvatarBuilder
          grade={currentGrade}
          assets={characterAssets}
          onAvatarLoad={saveAvatar}
          config={{
            kc,
            ampEvents: eventService.getEvents(),
            appName: 'student-home',
          }}
          LoadingComponent={<LoadingScreen />}
          isTeacher={showTeacherAvatarBuilder}
          isMsStudent={showMiddleSchoolAvatarBuilder}
          k5StudentUsageLimitOptions={{
            redirectCallback: () => {
              navigate('/home/student');
            },
          }}
          xAPIEventsContextExtensions={{
            result: {
              'application-version':
                kebabCase(import.meta.env.VITE_APP_VERSION) || '1-0-0',
              view: isMiddleSchoolView ? 'middle-school' : 'elementary-school',
              'student-grade': currentGrade,
            },
          }}
        />
      </div>
    </div>
  );
};
